import React from 'react';

export const name = 'flag-SE';

export const FlagSE = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1341_8458)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#FFDA44"
      />
      <path
        d="M9.38897 10.4344H23.8968C23.5169 7.54796 22.1007 4.89804 19.912 2.97836C17.7232 1.05867 14.9112 0.000157227 11.9999 2.28048e-05C11.1219 -0.00168583 10.2464 0.0926248 9.38897 0.281273V10.4344ZM6.2624 10.4344V1.45784C4.60126 2.36318 3.1775 3.64817 2.10714 5.2081C1.03678 6.76803 0.350091 8.55876 0.103027 10.4344H6.2624ZM6.2624 13.5656H0.103027C0.350091 15.4413 1.03678 17.232 2.10714 18.7919C3.1775 20.3519 4.60126 21.6369 6.2624 22.5422V13.5656ZM9.38897 13.5656V23.7141C10.2462 23.9043 11.1218 24.0002 11.9999 24C14.9112 23.9999 17.7232 22.9414 19.912 21.0217C22.1007 19.102 23.5169 16.4521 23.8968 13.5656H9.38897Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_1341_8458">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
